<template lang="pug">
  content-page
    h1(v-html="contentpage.name")
    ws-content(:value="contentpage.content" )
      webcam-list(:items="country.areas")
    div(slot="nav")
      navigation
      ad
</template>

<script>
import gql from 'graphql-tag';
import { interpolateFields } from '@/utils/interpolate.js';
import Navigation from '@/components/navigation';
import WebcamList from '@/components/webcam-list';
import MetaFragment from '@/components/graphql/metaFragment.graphql';
import Content from '@dengl/common/components/content.vue';

export default {
	name: 'WeatherWebcamsCountry',
	components: {
		Navigation,
		WebcamList
	},
	layout: 'default',
	nuxtI18n: {
		paths: {
			'nl-NL': '/weersneeuw/webcams/:country',
			'nl-BE': '/weersneeuw/webcams/:country',
			'de-DE': '/wetter-schnee/webcams/:country'
		}
	},
	asyncData({ params, app, route }) {
		const client = app.$graphClient;

		return client
			.query({
				query: gql`
					query getWebcamdata($slug: String, $path: String) {
						contentpage(path: $path) {
							id
							name
							slug
							content {
								...ContentDataFragment
							}
							...MetaFragment
						}
						country(slug: $slug) {
							id
							name
							slug
							webcamCount
							areas: areasWithWebcams(first: 250) {
								name
								slug
								stats {
									webcamCount
								}
								webcamLarge {
									name
									id
									preview
								}
								webcamSmall {
									name
									id
									preview
								}
							}
						}
					}
					${MetaFragment}
					${Content.fragments}
				`,
				variables: {
					slug: params.country,
					path: route.path.replace(params.country, '_country')
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (errors) {
					throw errors[0];
				}
				const interPolateFunction = interpolateFields({
					find: /{(country)}/gi,
					replace: data.country.name
				});
				interPolateFunction(data.contentpage, ['name']);
				interPolateFunction(data.contentpage.content, ['markdown']);
				interPolateFunction(data.contentpage.meta, ['title', 'description']);

				app.ads({
					navigation: { visible: true, targets: { country: data.country.id } }
				});
				app.meta(data.contentpage.meta);
				app.breadcrumbs({
					[app.i18n.t('page.weather:breadcrumb')]: { name: 'weather' },
					[app.i18n.t('page.weather.webcams:heading')]: {
						name: 'weather-webcams'
					},
					[data.contentpage.name]: {
						name: 'weather-webcams-country',
						params: { country: params.country }
					}
				});

				return data;
			})
			.catch(error => {
				return app.httpError(500, null, 'weather-webcams-country-01', error);
			});
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
